import {Impuesto} from './impuesto';

export class Item {
    numeroItem: number;
    descripcionProducto: string;
    codProductoSunat: string;
    codigoProducto: string;
    cantidadItems: number;
    unidad: string;
    valorUnitario: number;
    precioVentaUnitario: number;
    valorVenta: number;
    montoTotalImpuestos: number; // DET/totalImpuestos/montoImpuesto
    totalImpuestos: Impuesto[];
    affectationIGV?: string;
    descuento?: number = 0;
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/emisorFacturas/recursos/modelo/item.ts